import { css, cx } from "@emotion/css"
import { ComponentPropsWithoutRef } from "react"

const styles = {
  root: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
  `,
}

export type IconProps = ComponentPropsWithoutRef<"span">

export default function Icon(props: IconProps) {
  const { className, children, ...rest } = props
  const cn = cx("ui-Icon", styles.root, className)

  return (
    <span className={cn} {...rest}>
      {children}
    </span>
  )
}
